export default __webpack_public_path__ + "static/media/primary-logo.c9a14332.svg";